import React from 'react';
import { injectIntl } from '@atlassian/jira-intl';
import { shortDateFormat } from '@atlassian/jira-portfolio-3-common/src/date-manipulation/constants.tsx';
import { useDateFormatter } from '@atlassian/jira-portfolio-3-common/src/date-manipulation/format.tsx';
import { getTodayDate } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/timeline';
import messages from '../messages';
import type { Props } from './types';

function ExportDate({ intl }: Props) {
	const { formatTimestamp } = useDateFormatter();
	return (
		<div>
			{intl.formatMessage(messages.exportDisclaimerSpork, {
				date: formatTimestamp(getTodayDate().getTime(), shortDateFormat),
			})}
		</div>
	);
}

export default injectIntl(ExportDate);
